import { render, staticRenderFns } from "./addThesis.vue?vue&type=template&id=5292355c&scoped=true&"
import script from "./addThesis.vue?vue&type=script&lang=js&"
export * from "./addThesis.vue?vue&type=script&lang=js&"
import style0 from "./addThesis.vue?vue&type=style&index=0&id=5292355c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5292355c",
  null
  
)

export default component.exports